import { render, staticRenderFns } from "./add-channel-form-DVB-S.vue?vue&type=template&id=008d7794&"
import script from "./add-channel-form-DVB-S.vue?vue&type=script&lang=ts&"
export * from "./add-channel-form-DVB-S.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports